import React, { useEffect, useRef, useState } from 'react'
import '../Login.css' // 下面会给你对应的 css
import axios from 'axios'
import api from "../api";
import { useNavigate } from 'react-router-dom';
import { Cell,Toast, Dialog } from 'react-vant'
import backIcon from '../img/返回.svg'
import odanceLogo from '../img/ODance.png'
import BoosterNativeBridge from '../jsBridge'
import { useTranslation } from 'react-i18next'
import { setLanguage } from '../i18n'
import userAgreementEn from '../locales/userAgreementEn'
import privacyPolicyEn from '../locales/privacyPolicyEn'

const Login = () => {
  const { t, i18n } = useTranslation()
  // 海外版（en）只保留邮箱登录；国内版（zh）邮箱 + 手机号双 tab
  const isOverseas = i18n.language === 'en'
  const [activeTab, setActiveTab] = useState('email') // 'email' | 'phone'
  const [phone, setPhone] = useState('')
  const [code, setCode] = useState('')
  const [email, setEmail] = useState('')
  const [emailCode, setEmailCode] = useState('')
  const [countdown, setCountdown] = useState(0)
  const [emailCountdown, setEmailCountdown] = useState(0)
  const [emailCodeDisabled, setEmailCodeDisabled] = useState(false)
  const [agree, setAgree] = useState(false)
  const [imageCode, setImageCode] = useState('')
  const [codeDisabled, setCodeDisabled] = useState(false)
  const [sending, setSending] = useState(false) // 短信验证码发送中
  const [emailSending, setEmailSending] = useState(false) // 邮箱验证码发送中
  const [agreementDoc, setAgreementDoc] = useState(null) // null | 'user' | 'privacy'
  const timerRef = useRef(null)
  const emailTimerRef = useRef(null)
  const navigate = useNavigate()
  // 中国大陆手机号校验：以 1 开头 + 11 位数字
  const phoneRegex = /^1\d{10}$/
  const phoneValid = phoneRegex.test(phone)
  const canSubmit = phoneValid && code.trim() && agree
  const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  const canSubmitEmail = emailValid && emailCode.trim() && agree

  // 获取验证码
  const handleGetCode = async () => {
    if (!phoneValid) {
      Toast.info(t('login.phoneInvalid'))
      return
    }

    setCodeDisabled(true)
    setSending(true)

    try {
      // 为避免跨域，走开发环境代理：setupProxy.js 代理的是 /api
      const payload = {
        mobile: phone,
        type: 'login',
      }

      await api.login.post('/auth/api/v1/sms/send', payload)
      setSending(false)

      let countdownValue = 60
      setCountdown(countdownValue)

      if (timerRef.current) {
        clearInterval(timerRef.current)
      }

      timerRef.current = setInterval(() => {
        countdownValue--
        if (countdownValue > 0) {
          setCountdown(countdownValue)
        } else {
          clearInterval(timerRef.current)
          timerRef.current = null
          setCountdown(0)
          setCodeDisabled(false)
        }
      }, 1000)
    } catch (e) {
      console.error('sendMobileCode failed:', e)
      Toast.info(e?.response?.data?.message)
      setSending(false)
      setCountdown(0)
      setCodeDisabled(false)
    }
  }

  // 获取邮箱验证码
  const handleGetEmailCode = async () => {
    if (!emailValid) {
      Toast.info(t('login.emailInvalid'))
      return
    }

    setEmailCodeDisabled(true)
    setEmailSending(true)

    try {
      const payload = {
        email: email.trim(),
        type: 'login',
      }
      await api.sendEmailCode(payload)
      setEmailSending(false)

      let countdownValue = 60
      setEmailCountdown(countdownValue)

      if (emailTimerRef.current) {
        clearInterval(emailTimerRef.current)
      }

      emailTimerRef.current = setInterval(() => {
        countdownValue--
        if (countdownValue > 0) {
          setEmailCountdown(countdownValue)
        } else {
          clearInterval(emailTimerRef.current)
          emailTimerRef.current = null
          setEmailCountdown(0)
          setEmailCodeDisabled(false)
        }
      }, 1000)
    } catch (e) {
      console.error('sendEmailCode failed:', e)
      Toast.info(e?.response?.data?.message)
      setEmailSending(false)
      setEmailCountdown(0)
      setEmailCodeDisabled(false)
    }
  }

  useEffect(() => {
       console.log('🎯login useEffect');

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current)
        timerRef.current = null
      }
      if (emailTimerRef.current) {
        clearInterval(emailTimerRef.current)
        emailTimerRef.current = null
      }
    }
  }, [])

  // 登录成功：统一写入登录态并跳转首页
  const persistLogin = (res) => {
    console.log('登录成功，返回数据:', JSON.stringify(res));
    const resultData = res || {};
    const token = resultData.token || '';
    localStorage.setItem('auth_token', token);
    const userId =
      resultData?.userInfo?.userId ??
      resultData?.userInfo?.user_id ??
      resultData?.userId ??
      resultData?.user_id;
    if (userId === undefined || userId === null || String(userId).trim() === "") {
      localStorage.removeItem("user_id");
    } else {
      localStorage.setItem("user_id", String(userId));
    }
    navigate('/');
  };

  // 统一登录失败提示
  const toastLoginError = (error) => {
    console.error('登录异常:', error);
    let errorMsg = t('login.loginFailed');
    if (error.response) {
      const errorData = error.response.data;
      errorMsg = errorData?.message || errorData?.retDesc || errorMsg;
    } else if (error.request) {
      errorMsg = t('login.networkError');
    }
    Toast.info(errorMsg);
  };

  // 邮箱登录
  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmitEmail) {
      Toast.info(t('login.emailIncompleteTip'));
      return;
    }
    try {
      const res = await api.loginByEmail({ email: email.trim(), verCode: emailCode });
      persistLogin(res);
    } catch (error) {
      toastLoginError(error);
    }
  };

  // 手机号登录
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit) {
      Toast.info(t('login.phoneIncompleteTip'))
      return;
    }
    try {
      const res = await api.login.post('/auth/api/v1/login/', { mobile: phone, verCode: code });
      persistLogin(res);
    } catch (error) {
      toastLoginError(error);
    }
  };

  return (
    <div className="login-page">
      <button
        type="button"
        aria-label={t('login.back')}
        onClick={() => {
          // 优先走 Native close；非 Native 环境兜底用路由返回
          BoosterNativeBridge.close().catch(() => navigate(-1))
        }}
        style={{
          position: 'fixed',
          top: 20,
          left: 20,
          zIndex: 10,
          background: 'transparent',
          border: 'none',
          padding: 0,
          cursor: 'pointer',
        }}
      >
        <img
          src={backIcon}
          alt={t('login.back')}
          style={{ width: 24, height: 24, display: 'block' }}
        />
      </button>
      <div className="login-left">
        <div className="login-brand">
          <img className="login-logo" src={odanceLogo} alt={t('login.appName')} />
          <span className="login-brand-name">{t('login.appName')}</span>
        </div>
        <div className="login-slogan">{t('login.slogan')}</div>
      </div>

      <div className="login-right">
        <div className="lang-switch" role="group" aria-label={t('login.switchLang')}>
          <button
            type="button"
            className={`lang-tab ${i18n.language === 'zh' ? 'active' : ''}`}
            onClick={() => setLanguage('zh')}
          >
            中文
          </button>
          <button
            type="button"
            className={`lang-tab ${i18n.language === 'en' ? 'active' : ''}`}
            onClick={() => setLanguage('en')}
          >
            EN
          </button>
        </div>
        <div className="login-tabs">
          <button
            type="button"
            className={`login-tab ${activeTab === 'email' || isOverseas ? 'active' : ''}`}
            onClick={() => setActiveTab('email')}
          >
            {t('login.tabEmail')}
          </button>
          {!isOverseas && (
            <button
              type="button"
              className={`login-tab ${activeTab === 'phone' ? 'active' : ''}`}
              onClick={() => setActiveTab('phone')}
            >
              {t('login.tabPhone')}
            </button>
          )}
        </div>

        {!isOverseas && activeTab === 'phone' ? (
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-item">
            <div className="phone-input-wrap">
              <span className="phone-prefix">+86</span>
              <input
                type="tel"
                placeholder={t('login.phonePlaceholder')}
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                className="phone-input"
                maxLength={11}
              />
            </div>
          </div>


          <div className="form-item code-row">
            {/* 强制弹出数字键盘 */}
            <input
              type="text"
              inputMode="numeric"
              placeholder={t('login.phoneCodePlaceholder')}
              value={code}
              onChange={(e) => setCode(e.target.value)}
              className="login-input code-input"
            />
            <button
              type="button"
              className={`code-btn ${codeDisabled ? 'counting' : ''}`}
              disabled={codeDisabled || !phoneValid}
              onClick={handleGetCode}
            >
              {sending ? t('login.sending') : countdown > 0 ? t('login.codeCountdown', { countdown }) : t('login.sendCode')}
            </button>
          </div>

          <div className="agreement-row">
            <label className="agreement-label">
              <input
                type="checkbox"
                checked={agree}
                onChange={(e) => setAgree(e.target.checked)}
                className="agreement-checkbox"
              />
              <span className="agreement-text">
                {t('login.agreementPrefix')}
                <a href="#" onClick={(e) => { e.preventDefault(); setAgreementDoc('user'); }}>{t('login.userAgreement')}</a>
                {t('login.agreementAnd')}
                <a href="#" onClick={(e) => { e.preventDefault(); setAgreementDoc('privacy'); }}>{t('login.privacyPolicy')}</a>
              </span>
            </label>
          </div>

          <button type="submit"
                  className="login-btn"
                  disabled={!canSubmit}
                 >
            {t('login.submit')}
          </button>
        </form>
        ) : (
          <form onSubmit={handleEmailSubmit} className="login-form">
            <div className="form-item">
              <input
                type="email"
                placeholder={t('login.emailPlaceholder')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="login-input"
              />
            </div>

            <div className="form-item code-row">
              <input
                type="text"
                inputMode="numeric"
                placeholder={t('login.emailCodePlaceholder')}
                value={emailCode}
                onChange={(e) => setEmailCode(e.target.value)}
                className="login-input code-input"
              />
              <button
                type="button"
                className={`code-btn ${emailCodeDisabled ? 'counting' : ''}`}
                disabled={emailCodeDisabled || !emailValid}
                onClick={handleGetEmailCode}
              >
                {emailSending ? t('login.sending') : emailCountdown > 0 ? t('login.codeCountdown', { countdown: emailCountdown }) : t('login.sendCode')}
              </button>
            </div>

            <div className="agreement-row">
              <label className="agreement-label">
                <input
                  type="checkbox"
                  checked={agree}
                  onChange={(e) => setAgree(e.target.checked)}
                  className="agreement-checkbox"
                />
                <span className="agreement-text">
                  {t('login.agreementPrefix')}
                  <a href="#" onClick={(e) => { e.preventDefault(); setAgreementDoc('user'); }}>{t('login.userAgreement')}</a>
                  {t('login.agreementAnd')}
                  <a href="#" onClick={(e) => { e.preventDefault(); setAgreementDoc('privacy'); }}>{t('login.privacyPolicy')}</a>
                </span>
              </label>
            </div>

            <button
              type="submit"
              className="login-btn"
              disabled={!canSubmitEmail}
            >
              {t('login.submit')}
            </button>
          </form>
        )}
      </div>

      {agreementDoc && (
        <div
          className="agreement-modal"
          onClick={() => setAgreementDoc(null)}
        >
          <div className="agreement-modal-body" onClick={(e) => e.stopPropagation()}>
            <div className="agreement-modal-header">
              <span>{agreementDoc === 'user' ? t('login.userAgreementTitle') : t('login.privacyPolicyTitle')}</span>
              <button
                type="button"
                className="agreement-modal-close"
                onClick={() => setAgreementDoc(null)}
              >
                ×
              </button>
            </div>
            {isOverseas ? (
              <iframe
                className="agreement-modal-iframe"
                title={agreementDoc === 'user' ? t('login.userAgreementTitle') : t('login.privacyPolicyTitle')}
                srcDoc={agreementDoc === 'user' ? userAgreementEn : privacyPolicyEn}
              />
            ) : (
              <iframe
                className="agreement-modal-iframe"
                title={agreementDoc === 'user' ? t('login.userAgreementTitle') : t('login.privacyPolicyTitle')}
                src={process.env.PUBLIC_URL + (agreementDoc === 'user' ? '/user-agreement.html' : '/privacy-policy.html')}
              />
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default Login
